var exports = {
  "kp": "x31de4314--312314--kp",
};

module.exports = exports;
